<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      class="banner"
      tile
      :to="{
        name: 'dashboard.banner.edit',
        params: { id: banner._id },
      }"
    >
      <v-card-title
        v-if="title"
        class="justify-center text-no-wrap text-truncate"
      >
        <span class="d-inline-block text-truncate text-center h6">
          {{ banner.company.name }}
          <div class="text-caption success--text" v-if="banner.panelStatus">
            Banner Active
          </div>
          <div v-else class="text-caption error--text">
            Banner Paused
          </div>
        </span>
      </v-card-title>
      <v-card-text>
        <v-img
          :aspect-ratio="1 / 2"
          :src="`${banner.thumb}` | staticFilter"
          contain
        >
          <RibbonWatermark
            :text="banner.company.panelStatusText"
            :status="banner.company.panelStatus"
          />
          <template v-slot:placeholder>
            <v-row
              class="fill-height"
              align="center"
              justify="center"
              no-gutters
            >
              <v-progress-circular
                :size="30"
                :width="3"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-row>
          </template>
          <v-fade-transition>
            <v-overlay
              v-if="hover"
              absolute
              color="rgba(239, 63, 55, .8)"
              opacity="1"
            >
              <v-btn
                depressed
                tile
                x-large
                block
                width="160"
                height="60"
                v-if="role == 'ADMIN'"
                class="mx-auto"
                color="grey lighten-3 primary--text"
                >Edit</v-btn
              >
            </v-overlay>
          </v-fade-transition>
        </v-img>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "Banner",
  components: {
    RibbonWatermark: () => import("@/components/RibbonWatermark"),
  },
  props: {
    banner: Object,
    counter: Number,
    title: Boolean,
    editable: Boolean,
  },
  data() {
    return {
      overlay: false,
    };
  },
  computed: mapGetters(["role"]),
});
</script>
